import { Box, Typography } from "@mui/material";
import React from "react";

export const CustomTab = ({ tabs, active, onChangeTabValue }) => {
  return (
    <Box display={"flex"}>
      {tabs.map((name, idx) => {
        return (
          <Box
            key={idx}
            flex={1}
            mt={1}
            pt={1}
            pb={1}
            style={{
              borderBottom:
                active === idx
                  ? "2px solid #1D5AB9"
                  : "1px solid rgb(212, 212, 212)",
            }}
            onClick={() => {
              onChangeTabValue(idx);
            }}
          >
            <Typography
              color={active === idx ? "#1D5AB9" : "grey"}
              textAlign={"center"}
              fontWeight={"bold"}
            >
              {name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
